import { useExtendSession } from 'src/hooks/useExtendSession/useExtendSession'
import { useLogOutOnIdle } from 'src/hooks/useLogOutOnIdle/useLogOutOnIdle'
import { useRecheckSessionOnLogout } from 'src/hooks/useRecheckSessionOnLogout/useRecheckSessionOnLogout'

const EXTEND_SESSION_INTERVAL_MINUTES = parseInt(
  process.env.EXTEND_SESSION_INTERVAL_MINUTES ?? ''
)

const TimedSession = ({ children }: React.PropsWithChildren) => {
  useExtendSession(EXTEND_SESSION_INTERVAL_MINUTES * 1000 * 60)
  useLogOutOnIdle()
  useRecheckSessionOnLogout()
  return <>{children}</>
}

export default TimedSession
